import {CATEGORY, getBoardIdListingId, getDatesLabel, generic} from '../edap';
import edapUtils, {GENERIC_EVENT, trigger} from '../../utils/edap';
import debounce from 'lodash.debounce';

export const TYPES = {
    INVITE: 'invite',
    SHARE: 'share'
};

const voteActionStates = {
    ON: 'on',
    OFF: 'off'
};

export const named = {
    TRIPBOARDS_VOTE: 'tripboards.vote'
};

const tripboardsVote = (actionState, boardId, role, endDate, startDate) => {
    const accesstype = edapUtils.getEdapRoleFromRole(role);
    let options = {
        boardid: boardId,
        actionstate: actionState,
        accesstype
    };

    if (endDate && startDate) {
        options.eventenddate = endDate;
        options.eventstartdate = startDate;
    }

    trigger('tripboards.vote', options);
};

export function getEventLabel(boardId, type = TYPES.SHARE) {
    const value = getBoardIdListingId(boardId);
    return `${value};type=${type}`;
}

export function createTrigger(eventaction) {
    return function(boardId, endDate, startDate, type) {
        trigger(GENERIC_EVENT, {
            eventaction,
            eventcategory: CATEGORY,
            eventlabel: `${getEventLabel(boardId, type)};${getDatesLabel(startDate, endDate)}`
        });
    };
}

export function acceptInvite(boardId, endDate, startDate) {
    trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_INVITE_ACCEPT,
        eventcategory: CATEGORY,
        eventlabel: `${getBoardIdListingId(boardId)};${getDatesLabel(startDate, endDate)}`
    });
}

export function buttonClick(boardId, endDate, startDate) {
    trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_COLLABORATE_CLICK,
        eventcategory: CATEGORY,
        eventlabel: `${getBoardIdListingId(boardId)};${getDatesLabel(startDate, endDate)}`
    });
}

export function invalidInvite(inviteId) {
    trigger(GENERIC_EVENT, {
        eventaction: generic.TRIP_BOARDS_INVITE_INVALID,
        eventcategory: CATEGORY,
        eventlabel: `iid=${inviteId}`
    });
}

export function expiredInviteModalPop(inviteId, boardId) {
    trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_EXPIRED_POP,
        eventlabel: `iid=${inviteId};${getBoardIdListingId(boardId)}`
    });
}

export function expiredInviteModalClose(inviteId, boardId) {
    trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_EXPIRED_CLOSE,
        eventlabel: `iid=${inviteId};${getBoardIdListingId(boardId)}`
    });
}

export function expiredInvitePublicTripboardViewClick(inviteId, boardId) {
    trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_EXPIRED_VIEW_TRIPBOARD_CLICK,
        eventlabel: `iid=${inviteId};${getBoardIdListingId(boardId)}`
    });
}

export function invalidInviteModalPop(inviteId) {
    trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_INVALID_POP,
        eventlabel: `iid=${inviteId}`
    });
}

export function invalidInviteModalClose(inviteId) {
    trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_INVALID_CLOSE,
        eventlabel: `iid=${inviteId}`
    });
}

export function validInviteModalPop(inviteId, boardId) {
    trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_MODAL_POP,
        eventlabel: `iid=${inviteId};bid=${boardId}`
    });
}

export function validInviteModalClose(inviteId, boardId, closeType) {
    trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_MODAL_CLOSE,
        eventlabel: `iid=${inviteId};bid=${boardId};action=${closeType}`
    });
}

export function validInviteModalLogin(inviteId, boardId) {
    trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_INVITE_MODAL_LOGIN,
        eventlabel: `iid=${inviteId};bid=${boardId}`
    });
}

export function votedUp(boardId, endDate, listingId, startDate, role) {
    tripboardsVote(voteActionStates.ON, boardId, role, startDate, endDate);
    trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_VOTES_VOTE_UP,
        eventlabel: `${getBoardIdListingId(boardId, listingId)};${getDatesLabel(startDate, endDate)}`
    });
}

export function votedDown(boardId, endDate, listingId, startDate, role) {
    tripboardsVote(voteActionStates.OFF, boardId, role, startDate, endDate);
    trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_VOTES_VOTE_DOWN,
        eventlabel: `${getBoardIdListingId(boardId, listingId)};${getDatesLabel(startDate, endDate)}`
    });
}

export function votersClose(boardId, listingId) {
    trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_VOTES_VOTERS_CLOSE,
        eventlabel: getBoardIdListingId(boardId, listingId)
    });
}

export function votersOpen(boardId, listingId) {
    trigger(GENERIC_EVENT, {
        eventcategory: CATEGORY,
        eventaction: generic.TRIP_BOARDS_VOTES_VOTERS_OPEN,
        eventlabel: getBoardIdListingId(boardId, listingId)
    });
}

export const copyClick = createTrigger(generic.TRIP_BOARDS_COPY_CLICK);
export const copyUrl = createTrigger(generic.TRIP_BOARDS_COPY_URL);
export const cutUrl = createTrigger(generic.TRIP_BOARDS_CUT_URL);

/** @todo why is the close event firing twice? */
/* istanbul ignore next */
export const debouncedVotersClose = debounce(votersClose, 250, {
    leading: false,
    trailing: true
});

export default {
    acceptInvite,
    buttonClick,
    copyClick,
    copyUrl,
    cutUrl,
    expiredInviteModalPop,
    expiredInviteModalClose,
    expiredInvitePublicTripboardViewClick,
    invalidInvite,
    invalidInviteModalPop,
    invalidInviteModalClose,
    validInviteModalPop,
    validInviteModalClose,
    validInviteModalLogin,
    votedUp,
    votedDown,
    votersClose: debouncedVotersClose,
    votersOpen
};



// WEBPACK FOOTER //
// ./src/universal/tripboard/collaborate/edap.js